import * as React from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import { UpdateResetPassword } from '../../utils/axios/ResetpasswordApi';
import { useLocation } from "react-router-dom";
import { TimerAlert } from '../../utils/swtAlert';
import { ResetPassword } from "../../utils/axios/Auth";

function Resetpassword(props) {
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();
    // To retrive params from Url to convert into payload

    const search = useLocation().search;
    const Token = new URLSearchParams(search).get("Token");

    //Form Control Variables Starts..
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    //Form Control Variables Ends..
    const [confirmPasswordErr, setConfirmPasswordErr] = useState('');
    const [passwordMatch, setPasswordMatch] = useState(false);

    const confirmPasswordRef = useRef();
    const preventCopyPaste = (e) => {
        e.preventDefault()
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            if(passwordMatch){
                saveResetpassword();
            }
        }
    };

    const saveResetpassword = async () => {
        let payload = {
            newPassword: password
        }
        var result = await ResetPassword(Token, payload);
        if (result.success) {
            var delay = TimerAlert('success', 'Password Updated Successfully', 'success');
            setTimeout(() => navigate("/login"), delay);
        }
        else {
            TimerAlert('Password Updation Failed', 'Oops Something Went Wrong', 'error');
        }
    }

    const handleConfirmPassword = (e) => {
        
        if (password.length && confirmPassword.length > 0) {
            if (password !== confirmPassword) {
                confirmPasswordRef.current.style.border = "1px solid red"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px #e6707b"
                setConfirmPasswordErr("Passwords doesn't match");
                setPasswordMatch(false);
            }
    
            else {
                confirmPasswordRef.current.style.border = "1px solid green"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px green"
                setConfirmPasswordErr("");
                setPasswordMatch(true);
            }
        }
        else {
            confirmPasswordRef.current.style.border = "1px solid lightgray"
            confirmPasswordRef.current.style.boxShadow = "none"
            setConfirmPasswordErr("");
            setPasswordMatch(false);
        }
    }
    useEffect(() => {
            handleConfirmPassword();
    }, [password, confirmPassword]);

    return (
        <div className="rootmain border-top-wide border-primary d-flex flex-column theme-light">
            <div className='page page-center'>
                <div className='container-tight py-4'>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} className='card card-md'>
                        <div className='card-body'>
                            <h3 className='card-title text-center mb-4'>Reset password</h3>
                            <p className='text-muted mb-4'>Enter your new password to access our application</p>
                            <Form.Group className="mb-3">
                                <Form.Label>Password <em className="Required">*</em> </Form.Label>
                                <div className='col'>
                                    <Form.Control type="password" onChange={(e) => setPassword(e.target.value)} onCopy={(e) => preventCopyPaste(e)} onPaste={(e) => preventCopyPaste(e)} onCut={(e) => preventCopyPaste(e)} placeholder="Enter your Password" required />
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3"  >
                                <Form.Label>ConfirmPassword <em className="Required">*</em> </Form.Label>
                                <Form.Control ref={confirmPasswordRef}  type="password" id="ConfirmPassword" value={confirmPassword} placeholder="Enter Confirm New Password" onChange={(e) => setConfirmPassword(e.target.value)} onCopy={(e) => preventCopyPaste(e)} onPaste={(e) => preventCopyPaste(e)} onCut={(e) => preventCopyPaste(e)} required />
                                {passwordMatch && <span style={{ color: 'green' }}>Passwords Match</span>}
                                {!passwordMatch && <span style={{ color: 'red' }}>{confirmPasswordErr}</span>}
                            </Form.Group>
                            <Button className='w-100' variant="primary" type="submit">
                                Reset Password
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default Resetpassword;
